import { CardWrapper } from '@design-system';
import { FC, ReactNode } from 'react';
import {
  render,
  StoryblokRichtext,
} from 'storyblok-rich-text-react-renderer-ts';

interface Props {
  emoji?: string;
  text?: StoryblokRichtext;
  title?: string;
}

const paragraph = (children: ReactNode) => (
  <p className="text-pretty">{children}</p>
);

export const TextCard: FC<Props> = ({ emoji, text, title }) => (
  <CardWrapper variant="tertiary">
    <div className="flex h-full w-full gap-4 overflow-hidden p-4 md:flex-col md:gap-6 md:p-6">
      {emoji && <div className="text-md md:text-lg">{emoji}</div>}

      <div className="flex w-full flex-col gap-2">
        {title && <h3 className="text-md font-bold">{title}</h3>}
        {text && (
          <div className="flex flex-col gap-2">
            {render(text, { nodeResolvers: { paragraph } })}
          </div>
        )}
      </div>
    </div>
  </CardWrapper>
);
